import { ReactNode } from 'react'
import classNames from 'classnames'

import styles from './option-props.module.scss';


export type OptionPropsProps = {
  children: ReactNode
  className?: string
}

const OptionProps = ({ children, className }: OptionPropsProps) => (
  <dl className={classNames(styles.root, className)}>
    {children}
  </dl>
)

export default OptionProps
